export const FETCH_CATEGORIES = 'category/FETCH_CATEGORIES';
export const FETCH_CATEGORIES_SUCCESS = 'category/FETCH_CATEGORIES_SUCCESS';
export const FETCH_CATEGORIES_FAILED = 'category/FETCH_CATEGORIES_FAILURE';

export const ADD_CATEGORY = 'category/ADD_CATEGORY';
export const ADD_CATEGORY_SUCCESS = 'category/ADD_CATEGORY_SUCCESS';
export const ADD_CATEGORY_FAILED = 'category/ADD_CATEGORY_FAILURE';

export const UPDATE_CATEGORY = 'category/UPDATE_CATEGORY';
export const UPDATE_CATEGORY_SUCCESS = 'category/UPDATE_CATEGORY_SUCCESS';
export const UPDATE_CATEGORY_FAILED = 'category/UPDATE_CATEGORY_FAILURE';

export const DELETE_CATEGORY = 'category/DELETE_CATEGORY';
export const DELETE_CATEGORY_SUCCESS = 'category/DELETE_CATEGORY_SUCCESS';
export const DELETE_CATEGORY_FAILED = 'category/DELETE_CATEGORY_FAILURE';

export const LINK_LOGO = 'category/LINK_LOGO';
export const LINK_LOGO_SUCCESS = 'category/LINK_LOGO_SUCCESS';
export const LINK_LOGO_FAILED = 'category/LINK_LOGO_FAILURE';

export const UPDATE_SEQUENCE = 'category/UPDATE_SEQUENCE';
export const UPDATE_SEQUENCE_SUCCESS = 'category/UPDATE_SEQUENCE_SUCCESS';
export const UPDATE_SEQUENCE_FAILED = 'category/UPDATE_SEQUENCE_FAILURE';
export const CHANGE_STATUS = 'category/CHANGE_STATUS';
export const UPDATE_CONTEXT_MENU = 'category/UPDATE_CONTEXT_MENU';

export const FETCH_FOLDERS = 'category/FETCH_FOLDERS';
export const FETCH_FOLDERS_SUCCESS = 'category/FETCH_FOLDERS_SUCCESS';
export const FETCH_FOLDERS_FAILED = 'category/FETCH_FOLDERS_FAILURE';
export const ADD_FILE_SUCCESS = 'fileActions/ADD_FILE_SUCCESS';

export const FETCH_FOLDER = 'category/FETCH_FOLDER';
export const FETCH_FOLDER_SUCCESS = 'category/FETCH_FOLDER_SUCCESS';
export const FETCH_FOLDER_FAILED = 'category/FETCH_FOLDER_FAILURE';
export const CATEGORY_PERMISSIONS = 'category/CATEGORY_PERMISSIONS';

export function fetchCategories(update, pageFolderId, kind) {
  return {
    type: FETCH_CATEGORIES,
    update,
    pageFolderId,
    kind,
  };
}

export function fetchCategoriesSuccess(categories, pageFolderId) {
  return {
    type: FETCH_CATEGORIES_SUCCESS,
    categories,
    pageFolderId,
  };
}

export function fetchCategoriesFailed(err) {
  return {
    type: FETCH_CATEGORIES_FAILED,
    err,
  };
}

export function AddCategory(details) {
  return {
    type: ADD_CATEGORY,
    details,
  };
}

export function AddCategorySuccess(category) {
  return {
    type: ADD_CATEGORY_SUCCESS,
    category,
  };
}

export function AddCategoryFailed(err) {
  return {
    type: ADD_CATEGORY_FAILED,
    err,
  };
}

export function updateCategory(details) {
  return {
    type: UPDATE_CATEGORY,
    details,
  };
}

export function updateCategorySuccess(category) {
  return {
    type: UPDATE_CATEGORY_SUCCESS,
    category,
  };
}

export function updateCategoryFailed(err) {
  return {
    type: UPDATE_CATEGORY_FAILED,
    err,
  };
}

export function deleteCategory(details) {
  return {
    type: DELETE_CATEGORY,
    details,
  };
}

export function deleteCategorySuccess(category) {
  return {
    type: DELETE_CATEGORY_SUCCESS,
    category,
  };
}

export function deleteCategoryFailed(err) {
  return {
    type: DELETE_CATEGORY_FAILED,
    err,
  };
}

export function linkLogo(logoId, categoryId, remove) {
  return {
    type: LINK_LOGO,
    logoId,
    categoryId,
    remove,
  };
}

export function linkLogoSuccess(logo) {
  return {
    type: LINK_LOGO_SUCCESS,
    logo,
  };
}

export function linkLogoFailed(err) {
  return {
    type: LINK_LOGO_FAILED,
    err,
  };
}

export function updateSequence(details) {
  return {
    type: UPDATE_SEQUENCE,
    details,
  };
}

export function updateSequenceSuccess(categories) {
  return {
    type: UPDATE_SEQUENCE_SUCCESS,
    categories,
  };
}

export function updateSequenceFailed(err) {
  return {
    type: UPDATE_SEQUENCE_FAILED,
    err,
  };
}

export function updateStatus() {
  return {
    type: CHANGE_STATUS,
  };
}

export function updateContextData(data) {
  return {
    type: UPDATE_CONTEXT_MENU,
    data,
  };
}

export function fetchFolders(filters) {
  return {
    type: FETCH_FOLDERS,
    filters,
  };
}

export function fetchFoldersSuccess(folders, total) {
  return {
    type: FETCH_FOLDERS_SUCCESS,
    folders,
    total,
  };
}

export function fetchFoldersFailed(err) {
  return {
    type: FETCH_FOLDERS_FAILED,
    err,
  };
}

export function addUploadedFile(file) {
  return {
    type: ADD_FILE_SUCCESS,
    file,
  };
}

export function fetchFolder(uniqueId) {
  return {
    type: FETCH_FOLDER,
    uniqueId,
  };
}

export function fetchFolderSuccess(folder) {
  return {
    type: FETCH_FOLDER_SUCCESS,
    folder,
  };
}

export function fetchFolderFailed(err) {
  return {
    type: FETCH_FOLDER_FAILED,
    err,
  };
}

export function categoryPermission(permission) {
  return {
    type: CATEGORY_PERMISSIONS,
    permission,
  };
}
